import api from "./ApiURLBase";
const EndPointGetOperators = async (miningSite, id, dni, name, type) =>
  await api.get(`/operators/GetOperator?miningSiteId=${miningSite}&operatorId=${id}&dni=${dni}&name=${name}&type=${type}`);
const EndPointGetOperatorTypes = async () => await api.get(`/operators/GetOperatorType`);
const EndPointCreateUpdateOperator = async data => await api.post(`/operators/CreateUpdateOperator/`, data);
const EndPointDeleteOperator = async (id, miningSite) => await api.delete(`/operators/DeleteOperator/${id}/${miningSite}`);

export {
  EndPointGetOperators,
  EndPointGetOperatorTypes,
  EndPointDeleteOperator,
  EndPointCreateUpdateOperator
};
